import React, { useState, useEffect } from 'react';

//Componentes
import ComponenteExtra1440 from './ComponenteExtra1440';
import ComponenteExtra1024 from './ComponenteExtra1024';
import ComponenteExtra768 from './ComponenteExtra768';
import ComponenteExtra380 from './ComponenteExtra380';

export default function Encabezado({ LogoBanner, TextoBanner }) {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        // Eliminar el listener cuando el componente se desmonte
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const renderComponent = (width) => {
        if (width >= 1440) {
            return <ComponenteExtra1440 Logo={LogoBanner} Texto={TextoBanner} />;
        } else if (width >= 1024) {
            return <ComponenteExtra1024 Logo={LogoBanner} Texto={TextoBanner} />;
        } else if (width >= 768) {
            return <ComponenteExtra768 Logo={LogoBanner} />;
        } else {
            return <ComponenteExtra380 Logo={LogoBanner} />;
        }
    };

    return renderComponent(windowWidth);
}